import { hasFlag } from './auth.js';

export type OptimizeDryParsedArgs =
  | {
      ok: true;
      runId: string;
      workflowId?: string;
      outDir: string;
      json: boolean;
    }
  | { ok: false; error: string };

function optionValue(argv: string[], name: string): string | undefined {
  const index = argv.indexOf(name);
  if (index === -1) return undefined;
  const value = argv[index + 1];
  if (!value || value.startsWith('-')) return undefined;
  return value;
}

export function parseOptimizeDryArgs(argv: string[]): OptimizeDryParsedArgs {
  const runId = optionValue(argv, '--run');
  if (!runId) {
    return {
      ok: false,
      error: 'optimize-dry requires --run <runId>',
    };
  }
  const workflowId = optionValue(argv, '--workflow');
  const outDir = optionValue(argv, '--out') ?? `./cache-opt-${runId}`;
  return {
    ok: true,
    runId,
    ...(workflowId ? { workflowId } : {}),
    outDir,
    json: hasFlag(argv, '--json'),
  };
}
